// @ts-nocheck

import { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import useStoreTimToa from "../../../store/useStoreTimToa";
import { Icons } from "../../spinner";
import { Info } from "@phosphor-icons/react"

export function OccupationBySupervisor() {
  const [options, setOptions] = useState({});
  const { workOccupationData, loadingChartWorkOccupation } = useStoreTimToa(
    (state) => state
  );


  const updateOptions = () => {
    if (!workOccupationData?.horas_por_supervisor) return;

    const supervisores = workOccupationData?.horas_por_supervisor.map(item => item.nome_supervisor)
    
    const series = [
      {
        name: 'Horas Disponíveis',
        type: 'bar',
        data: workOccupationData.horas_por_supervisor.map(supervisor => ({
          value: supervisor.horas_disponiveis,
          itemStyle: { color: '#4CAF50' }
        })),
        label: {
          show: true,
          position: 'top',
          color: '#fff',
          formatter: '{c}h'
        }
      },
      {
        name: 'Horas Trabalhadas',
        type: 'bar',
        data: workOccupationData.horas_por_supervisor.map(supervisor => ({
          value: supervisor.horas_trabalhadas,
          itemStyle: { color: '#2196F3' }
        })),
        label: {
          show: true,
          position: 'top',
          color: '#fff',
          formatter: '{c}h'
        }
      },
      {
        name: 'Horas Não Ocupadas',
        type: 'bar',
        data: workOccupationData.horas_por_supervisor.map(supervisor => ({
          value: supervisor.horas_nao_ocupadas,
          itemStyle: { color: '#FFC107' }
        })),
        label: {
          show: true,
          position: 'top',
          color: '#fff',
          formatter: '{c}h'
        }
      }
    ];

    const option = {
      title: {
        text: 'Taxa de Ocupação por Supervisor',
        left: 'center',
        textStyle: {
          color: '#fff',
          fontSize: 16,
          fontWeight: 'bold'
        },
        top: 5
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: function(params) {
          let tooltip = `${params[0].name}<br/>`;
          params.forEach(param => {
            tooltip += `${param.seriesName}: ${param.value}h<br/>`;
          });
          return tooltip;
        }
      },
      legend: {
        data: ['Horas Disponíveis', 'Horas Trabalhadas', 'Horas Não Ocupadas'],
        top: 30,
        textStyle: {
          color: '#fff'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        top: '25%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: supervisores,
        axisLabel: {
          color: '#fff',
          interval: 0,
          rotate: 0,
          width: 100,
          overflow: 'break'
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          color: '#fff',
          formatter: '{value}h'
        }
      },
      series: series
    };

    setOptions(option);
  };

  useEffect(() => {
    if (workOccupationData?.horas_por_supervisor) {
      updateOptions();
    }
  }, [workOccupationData]);

  return (
    <>
      {workOccupationData?.horas_por_supervisor ? (
        <div className="relative h-[450px] bg-gray-500 rounded-sm col-span-2">
          <div className="absolute top-2 right-2 z-10 group">
            <Info 
              className="h-5 w-5 text-white cursor-help" 
            />
            <div className="hidden group-hover:block absolute right-0 w-64 p-2 bg-gray-800 text-white text-sm rounded-md shadow-lg">
              Este gráfico mostra a distribuição das horas de trabalho, 
              indicando o total de horas disponíveis, horas efetivamente 
              trabalhadas e horas não ocupadas no período.
            </div>
          </div>
          <ReactECharts 
            option={options} 
            style={{ height: "450px", width: "100%" }} 
          />
        </div>
      ) : loadingChartWorkOccupation ? (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm col-span-2">
          <Icons.spinner className="h-12 w-12 animate-spin text-orange-300" />
        </div>
      ) : (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm col-span-2">
          <p className="bg-slate-100 p-2 text-gray-500 rounded-md font-extrabold ">
            SEM DADOS
          </p>
        </div>
      )}
    </>
  );
}